import { render, staticRenderFns } from "./space.vue?vue&type=template&id=3ffc994a&scoped=true"
var script = {}
import style0 from "./space.vue?vue&type=style&index=0&id=3ffc994a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc994a",
  null
  
)

export default component.exports